import { Button, Divider, Modal, Skeleton, Space } from "antd";
import { IModelInfo } from "../../domain/ModelInfos/IModelInfo";
import { nanoid } from "nanoid"
import { ModelInfoEditor } from "./ModelInfoEditor";
import { PageWrapper } from "../../controls/PageWrapper";
import { PageTitle } from "../../controls/PageTitle";
import { useDatasource } from "../../hooks/useDatasource";
import { domain } from "../../domain/domain";
import { orderBy } from "../../helpers/tsxHelper";
import { ExportProfileSelector } from "../../controls/ExportProfileSelector";
import { useState } from "react";
import { IExportProfile } from "../../domain/ExportProfiles/IExportProfile";
import { DeleteOutlined, PlusOutlined, SwapOutlined, UndoOutlined } from "@ant-design/icons";
import VisibilitySensor from "react-visibility-sensor"

export function ModelsPage(props: {}) {
    const datasource = useDatasource(() => domain.modelInfoService.get(), []);
    const [exportProfile, setExportProfile] = useState<IExportProfile | undefined>();
    console.log("render()");
    async function addModel() {
        const model: IModelInfo = {
            id: nanoid(),
            importId: nanoid(),
            created: new Date(),
            namespace: "default",
            name: "Model 1",
            extends: [],
            imports: [],
            members: [],
        };

        await domain.modelInfoService.save([model]);
        datasource.updateData();
    }

    function triggerUpdate() {
        datasource.updateData();
    }

    const items = orderBy(datasource.data, (x: IModelInfo) => [x.name]);

    async function convert() {
        if (!exportProfile) return;
        const models = await datasource.fetch()
        for (const model of models) {
            model.rev = nanoid();

            if (exportProfile.modelNameCaseConverter) {
                model.name = exportProfile.modelNameCaseConverter(model.name);
            }
            for (const member of model.members) {
                if (exportProfile.memberNameCaseConverter) {
                    member.name = exportProfile.memberNameCaseConverter(member.name);
                }
                if (exportProfile.typeConverter) {
                    exportProfile.typeConverter(member);
                }
            }
        }
        await domain.modelInfoService.save(models);
        datasource.updateData();
    }

    async function originalNames() {
        const models = await datasource.fetch()
        for (const model of models) {
            model.rev = nanoid();
            model.name = model.originalName ?? model.name;
            for (const member of model.members) {
                member.name = member.originalName ?? member.name;
            }
        }
        await domain.modelInfoService.save(models);
        datasource.updateData();
    }
    async function originalTypes() {
        const models = await datasource.fetch()
        for (const model of models) {
            model.rev = nanoid();
            for (const member of model.members) {
                member.type.name = member.type.originalName ?? member.type.name;
            }
        }
        await domain.modelInfoService.save(models);
        datasource.updateData();
    }

    function deleteAll() {
        Modal.confirm({
            content: `Really delete ALL models?`,
            okText: "Delete",
            onOk: async () => {
                await domain.modelInfoService.deleteAll();
                datasource.updateData();
            }
        });
    }

    return (
        <PageWrapper>
            <PageTitle title="Models" />
            <div style={{ padding: 24, minHeight: 360, backgroundColor: "#fff" }}>
                <Space direction="vertical">
                    <Space>
                        <Button icon={<PlusOutlined />} onClick={addModel}>Add model</Button>
                        <Button icon={<UndoOutlined />} onClick={originalNames}>Original names</Button>
                        <Button icon={<UndoOutlined />} onClick={originalTypes}>Original types</Button>
                        <div><ExportProfileSelector onChange={setExportProfile} /></div>
                        <Button icon={<SwapOutlined />} onClick={convert}>Convert</Button>
                        <Divider type="vertical" />
                        <Button icon={<DeleteOutlined />} type="primary" danger onClick={deleteAll}>Delete All</Button>
                    </Space>
                </Space>

                <div style={{ display: "grid", marginTop: "20px", gridTemplateColumns: "repeat(auto-fill, 500px)", columnGap: "1rem", rowGap: "1rem" }}>
                    {items.map(x => <VisibilitySensor key={`${x.id}-${x.rev}`} partialVisibility offset={{ top: 50, bottom: 50 }}>
                        {(z: { isVisible: boolean }) => z.isVisible ? <ModelInfoEditor model={x} triggerUpdate={triggerUpdate} /> : <div style={{ height: 500 }}><Skeleton paragraph={{ rows: 4 }} /></div>}
                    </VisibilitySensor>)}
                </div>
            </div>
        </PageWrapper>
    );
};


